(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clrty-video-hero"] && !Shopify.designMode) return;
  try {
    
class ClrtyHeroMedia extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.video = this.querySelector('video');
    if (!this.video) return;
    this.poster = this.querySelector('img');
    this.breakpoint = matchMedia('(max-width: 749px)');
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.inView = true;
    this.generation = 0;
    const options = { signal: this.controller.signal };
    const sync = () => this.sync();
    this.breakpoint.addEventListener('change', sync, options);
    this.motion.addEventListener('change', sync, options);
    document.addEventListener('visibilitychange', sync, options);
    navigator.connection?.addEventListener('change', sync, options);
    this.video.addEventListener('playing', () => {
      if (this.shouldPlay()) this.setAttribute('data-playing', '');
      else this.video.pause();
    }, options);
    this.video.addEventListener('error', () => this.removeAttribute('data-playing'), options);
    this.observer = new IntersectionObserver(entries => {
      this.inView = entries[0].isIntersecting;
      this.sync();
    });
    this.observer.observe(this);
    this.sync();
  }

  shouldPlay() {
    return this.isConnected && !document.hidden && this.inView &&
      !this.motion.matches && !navigator.connection?.saveData;
  }

  async sync() {
    const token = ++this.generation;
    const source = this.breakpoint.matches ? this.dataset.mobileSrc : this.dataset.desktopSrc;
    if (!source || !this.shouldPlay()) {
      this.video.pause();
      if (!source || this.motion.matches || navigator.connection?.saveData) {
        this.removeAttribute('data-playing');
        if (this.video.hasAttribute('src')) {
          this.video.removeAttribute('src');
          this.video.load();
        }
      }
      return;
    }
    if (this.video.getAttribute('src') !== source) {
      this.removeAttribute('data-playing');
      if (this.video.hasAttribute('src')) {
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.load();
      }
      if (this.poster && !this.poster.complete) {
        try { await this.poster.decode(); } catch {}
      }
      await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
      if (token !== this.generation || !this.shouldPlay()) return;
      this.video.muted = true;
      this.video.src = source;
      this.video.load();
    }
    if (token !== this.generation || !this.shouldPlay()) return;
    try { await this.video.play(); } catch {}
  }

  disconnectedCallback() {
    ++this.generation;
    this.video?.pause();
    this.observer?.disconnect();
    this.controller?.abort();
    this.controller = null;
  }
}

if (!customElements.get('clrty-hero-media')) {
  customElements.define('clrty-hero-media', ClrtyHeroMedia);
}

  } catch(e) { console.error(e); }
})();
})();
